import { atom } from "recoil";
import { getRecoil, setRecoil } from "../providers/RecoilAccessProvider";
import { SkillListEntry } from "../types/skillList";

/** The company's skills as the server last reported them, shared by every skill input. */
export const skillListState = atom<{ entries: SkillListEntry[], loadedAt: number }>({
    key: "skills.list",
    default: { entries: [], loadedAt: 0 },
});

/** A save changed someone's skills; the next input to show up loads the list again. */
export function markSkillListStale() {
    setRecoil(skillListState, { ...getRecoil(skillListState), loadedAt: 0 });
}
